import { render, staticRenderFns } from "./PromoBarD.vue?vue&type=template&id=5ea9d7a7&scoped=true&"
import script from "./PromoBarD.vue?vue&type=script&lang=js&"
export * from "./PromoBarD.vue?vue&type=script&lang=js&"
import style0 from "./PromoBarD.vue?vue&type=style&index=0&id=5ea9d7a7&prod&lang=css&"
import style1 from "./PromoBarD.vue?vue&type=style&index=1&id=5ea9d7a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9d7a7",
  null
  
)

export default component.exports